import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Select, Row, message } from 'antd';
import mondaySdk from "monday-sdk-js";
import toastHandler from '../../../firebaseService/toastHandler';
import MondayConfig from '../../../configs/MondayConfig';
import sentryUtils from '../../../utils/sentryUtils';

const SelectStatusColumn = (props) => {
    const { placeholder, data, form, field, cb, error, value, disabled, selectedProject, setFieldValue } = props;

    
    const { name } = field;
    const monday = mondaySdk();
    monday.setApiVersion(MondayConfig.MONDAY_API_VERSION)
    const [statusColumns, setstatusColumns] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [busy, setBusy] = useState(false);
    const [isFirst, setIsFirst] = useState(true)

    const fetchColumn = async () => {
        console.log('fetchColumn called')
        if (
            selectedProject !== null &&
            selectedProject !== '' &&
            selectedProject.key !== undefined
        ) {
            setBusy(true);

            let query = `query {
                boards (ids: ` + selectedProject.key + `) {
                  columns(types: status) {
                    id
                    title
                    type
                  }		
                }
              }`;


            const tokendata = await monday.get('sessionToken');
            const response = await monday.api(query, {
                options: { token: tokendata.data },
            }).catch((err) => {
                setBusy(false);
                console.log('error in fetch column --->', err.message);
                toastHandler.error(err.message);
                sentryUtils.captureMondayException('fetchColumn', error, 'selectStatusColumn');
            });
           
            let columnList = response.data.boards[0]?.columns || [];

            columnList = _.orderBy(columnList, ['title'], ['asc']);
            let columns = [];
            columnList.forEach((item, index) => {
                columns.push({
                    key: item.id,
                    label: item.title,
                    value: item.id,
                });
            });
            setstatusColumns(columns);
            setBusy(false);
        }
    };

    useEffect(() => {
        if (!_.isEmpty(selectedProject)) {
            fetchColumn();
            setIsFirst(true)
        }
    }, [selectedProject]);

    useEffect(() => {
        if(name === 'statusColumnName' && statusColumns.length === 0){
            if(!isFirst){
                message.error("Add status column to your monday board");
                // toastHandler.error("Add status column to your monday board");
            } else {
                setIsFirst(false)
            }
        }
        if (statusColumns.length > 0 && value) {
            const data = statusColumns.filter((item) => item.value === value);

            if(data.length > 0){
                cb(data);
                setSelectedValue(data[0]);
            } else {
                setSelectedValue(null);
                if(value){
                    message.error("Your previouslly set status's column is deleted from monday board");
                    // toastHandler.error("Your previouslly set status's column is deleted from monday board");
                }
            }
            
        } else {
            setSelectedValue(null);
        }
    }, [statusColumns, value])

    return (
        <div>
            <Row>
                <Select
                    placeholder={placeholder}
                    style={{ width: '100%' }}
                    disabled={disabled}
                    name={name}
                    value={selectedValue}
                    allowClear
                    onClear={() => {
                        setFieldValue("statusColumnName",null);
                        setFieldValue("statusColumnId",0);
                        setFieldValue("statusColumnLabelName",null);
                    }}
                    showSearch
                    optionFilterProp='label'
                    onChange={(e) => {
                        const selectedValue = statusColumns.filter((item) => item.value === e);
                        cb(selectedValue)
                    }}
                    loading={busy}
                >
                    {statusColumns?.map((item) => (
                        <Select.Option key={item.key} value={item.value} label={item.label}>
                            {item.label}
                        </Select.Option>
                    ))}
                </Select>
            </Row>
            {error ? <Row><span style={{ fontSize: 11, color: 'red' }}>{error}</span></Row> : null}
        </div >
    )
};

export default SelectStatusColumn;
